import "./datatable.scss";
import { DataGrid } from "@mui/x-data-grid";
import { userColumns } from "../../datatablesource";
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  collection,
  onSnapshot,
} from "firebase/firestore";
import { db } from "../../../../firebase";
import userController from "../../../../controllers/usercontroller";

let theme0 = 'Tous les thèmes'

let groupTheme1 = 'Amélioration des variétés et des semences';
let groupTheme2 = 'Amélioration et restauration des sols';
let groupTheme3 = 'Protection des plantes';
let groupTheme4 = 'Pisciculture';
let groupTheme5 = 'Agroindustrie';

const groupThemes = [
  {
    label: groupTheme1,
    value: groupTheme1
  },
  {
    label: groupTheme2,
    value: groupTheme2
  },
  {
    label: groupTheme3,
    value: groupTheme3
  },
  {
    label: groupTheme4,
    value: groupTheme4
  },
  {
    label: groupTheme5,
    value: groupTheme5
  }
]

let theme1 = 'Développer et diffuser une nouvelle variété de sorgho';
let theme2 = 'Développer et diffuser une nouvelle variété de riz/blé';
let theme3 = 'Développer et diffuser une nouvelle variété de manioc';
let theme4 = 'Développer et diffuser une nouvelle variété de céréales maïs';
let theme5 = 'Développer et diffuser une nouvelle variété de patate douce';
let theme6 = 'Développer et diffuser une nouvelle variété de haricot commun';
let theme7 = 'Développer et diffuser les biofertilisants à base des amendements organiques';
let theme8 = 'Développer et diffuser les biopesticides à bases de plantes';
let theme9 = 'Développer et diffuser les biopesticides à base de microorganismes';
let theme10 = 'Développer et diffuser des aliments pour poisson d’élevage';
let theme11 = 'Mise au point d’un tamis automatique pour le tri des graines';

const themes = [
  {
    label: theme0,
    value: theme0,
  },
  {
    label: theme1,
    value: theme1,
  },
  {
    label: theme2,
    value: theme2,
  },
  {
    label: theme3,
    value: theme3,
  },
  {
    label: theme4,
    value: theme4,
  },
  {
    label: theme5,
    value: theme5,
  },
  {
    label: theme6,
    value: theme6,
  },
  {
    label: theme7,
    value: theme7,
  },
  {
    label: theme8,
    value: theme8,
  },
  {
    label: theme9,
    value: theme9,
  },
  {
    label: theme10,
    value: theme10,
  },
  {
    label: theme11,
    value: theme11,
  }
];

const Datatable = () => {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [theme, setTheme] = useState({
    value: '',
  });
  let [submissionsList, setList] = useState([]);
  const id = localStorage.getItem('id');
  const type = localStorage.getItem('type');
  let [firstRender, setFirstRender] = useState({
    firstRender: true,
  });
  const [user, setUserTheme] = useState({
    theme: '',
  });

  useEffect(() => {
    if(type === 'exam'){
      if(firstRender){
        userController.getExamDetails(id).then(data => {
          if(data != null){
            setUserTheme(data.theme);
            // LISTEN (REALTIME)
            const unsub = onSnapshot(
              collection(db, "submissions"),
              (snapShot) => {
                snapShot.docs.forEach((doc) => {
                  if(doc.data().theme === data.theme){
                    submissionsList.push({ id: doc.id, ...doc.data() });
                  }

                  switch(data.theme){
                    case groupTheme1: 
                    if(
                      doc.data().theme === theme1 ||
                      doc.data().theme === theme2 ||
                      doc.data().theme === theme3 ||
                      doc.data().theme === theme4 ||
                      doc.data().theme === theme5 ||
                      doc.data().theme === theme6
                    ){
                      submissionsList.push({ id: doc.id, ...doc.data()});
                    }
                    break;
                    case groupTheme2: 
                    if(
                      doc.data().theme === theme7 ||
                      doc.data().theme === theme8 
                    ){
                      submissionsList.push({ id: doc.id, ...doc.data()});
                    }
                    break;
                    case groupTheme3: 
                    if(
                      doc.data().theme === theme9
                    ){
                      submissionsList.push({ id: doc.id, ...doc.data()});
                    }
                    break;
                    case groupTheme4:
                    if(
                      doc.data().theme === theme10
                    ){
                      submissionsList.push({ id: doc.id, ...doc.data()});
                    }
                    break;
                    case groupTheme5: 
                    if(
                      doc.data().theme === theme11
                    ){
                      submissionsList.push({ id: doc.id, ...doc.data()});
                    }
                    break;
                    default: break;
                  }
                });
                // setList(submissionsList);
                setData(submissionsList);
              },
              (error) => {
                console.log(error);
              }
            );
            setFirstRender(false);
            return () => {
              unsub();
            };
          }
        });
      }
    }
    else {
      // LISTEN (REALTIME)
      const unsub = onSnapshot(
        collection(db, "submissions"),
        (snapShot) => {
          snapShot.docs.forEach((doc) => {
            submissionsList.push({ id: doc.id, ...doc.data() });
          });
          // setList(submissionsList);
          setData(submissionsList);
        },
        (error) => {
          console.log(error);
        }
      );

      return () => {
        unsub();
      };
    }
  }, []);

  
  const handleGroupThemeChange = (e) => {
    theme.value = e.target.value;
    setTheme({...theme, [theme]:e.target.value});

    let list = [];
    if(theme.value.length < 1 || theme.value === theme0){
      setData(submissionsList);
    }
    else {
      submissionsList.forEach((item) => {
        switch(theme.value.toString()){
          case groupTheme1: 
          if(
            item.theme === theme1 ||
            item.theme === theme2 ||
            item.theme === theme3 ||
            item.theme === theme4 ||
            item.theme === theme5 ||
            item.theme === theme6
          ){
            list.push({ id: item.id, ...item});
          }
          break;
          case groupTheme2: 
          if(
            item.theme === theme7 ||
            item.theme === theme8
          ){
            list.push({ id: item.id, ...item});
          }
          break;
          case groupTheme3: 
          if(
            item.theme === theme9
          ){
            list.push({ id: item.id, ...item});
          }
          break;
          case groupTheme4: 
          if(
            item.theme === theme10 
          ){
            list.push({ id: item.id, ...item});
          }
          break;
          case groupTheme5: 
          if(
            item.theme === theme11 
          ){
            list.push({ id: item.id, ...item});
          }
          break;
          default: break;
        }
      });
      setData(list);
      list = [];
    }
  }

  const handleView = async (id) => {
    navigate(`${id}`);
  }

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="cellAction" >
            <div className="viewButton" onClick={() => handleView(params.row.id)}>Ouvrir</div>
          </div>
        );
      },
    },
  ];
  return (
    <div className="datatable">
      <div className="datatableTitle">
        <p className="ctitle">{t('applications_list')}</p>
      </div>
      {
        type === 'admin' ?
        <div>
            <select value={theme.value} onChange={handleGroupThemeChange}>
                {groupThemes.map((option) => (
                    <option value={option.value}>{option.label}</option>
                ))}
            </select>
            <p className="mt-4">{t('choosen_theme')} : <span className="fw-bolder">{theme.value.length < 1 ? t('no_choosen_theme') : theme.value}</span></p>
        </div>
        :
        <></>
      }
      <DataGrid
        className="datagrid"
        rows={data}
        columns={userColumns.concat(actionColumn)}
        pageSize={9}
        rowsPerPageOptions={[9]}
        
      />
    </div>
  );
};

export default Datatable;
